import styled from "styled-components";

import dynPaddingRight from "Utilities/interpolations/dynPaddingRight";

const IconWrapper = styled.div`
  ${dynPaddingRight}
  width: 15.5px;
  transform: translateX(${(props) => (props.$isSearchActive ? "-1px" : "2px")});
  transition: padding-right 200ms, transform 200ms;
`;

export default IconWrapper;
